import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Load from localStorage or use default
const loadActiveFormNameFromStorage = (): string => {
  try {
    const stored = localStorage.getItem("activeFormName");
    if (stored) {
      return stored;
    }
  } catch (error) {
    console.error("Error loading activeFormName from localStorage:", error);
  }
  return "2025 Conference Registration";
};

// Explicitly type the initial state
const initialState: {
  activeFormName: string;
} = {
  activeFormName: loadActiveFormNameFromStorage(),
};

// Slice for active form
const activeFormSlice = createSlice({
  name: "activeForm",
  initialState,
  reducers: {
    setActiveFormName: (state, action: PayloadAction<string>) => {
      state.activeFormName = action.payload;
      // Save to localStorage
      try {
        localStorage.setItem("activeFormName", action.payload);
      } catch (error) {
        console.error("Error saving activeFormName to localStorage:", error);
      }
    },
  },
});

export const { setActiveFormName } = activeFormSlice.actions;
export default activeFormSlice.reducer;
